import { MarketplaceIds } from '../../enums/marketplace-ids';
import completeLogo00 from './components/onboard-section/onboard-svgs/progress_complete_00.svg';
import completeLogo25 from './components/onboard-section/onboard-svgs/progress_complete_25.svg';
import completeLogo33 from './components/onboard-section/onboard-svgs/progress_complete_33.svg';
import completeLogo50 from './components/onboard-section/onboard-svgs/progress_complete_50.svg';
import completeLogo66 from './components/onboard-section/onboard-svgs/progress_complete_66.svg';
import completeLogo75 from './components/onboard-section/onboard-svgs/progress_complete_75.svg';
import completeLogo100 from './components/onboard-section/onboard-svgs/progress_complete_100.svg';
import { OrderImportCard } from './components/onboard-section/onboard-steps/order-import-card/order-import-card';
import { ShippingServicesCard } from './components/onboard-section/onboard-steps/shipping-service-card/shipping-services-card';
import { ShipFromCard } from './components/onboard-section/onboard-steps/ship-from-card/ship-from-card';
import { CheckoutRatesCard } from './components/onboard-section/onboard-steps/checkout-rates-card/checkout-rates-card';

export const checkoutRateMarketplaceIds = [
  MarketplaceIds.Shopify,
  MarketplaceIds.BigCommerceV3,
  MarketplaceIds.Wix,
  MarketplaceIds.Magento,
];

export const completedStepsSvgs = {
  '0/3': completeLogo00,
  '1/3': completeLogo33,
  '2/3': completeLogo66,
  '3/3': completeLogo100,
  '0/4': completeLogo00,
  '1/4': completeLogo25,
  '2/4': completeLogo50,
  '3/4': completeLogo75,
  '4/4': completeLogo100,
};

export const bigCommerceAffiliateCode = 'BigCommerce';

export const OnboardingSteps = {
  OrderImport: 'OrderImport',
  ShippingServices: 'ShippingServices',
  ShipFrom: 'ShipFrom',
  CheckoutRates: 'CheckoutRates',
};

export const OnboardingStepsComponents = {
  [OnboardingSteps.OrderImport]: OrderImportCard,
  [OnboardingSteps.ShippingServices]: ShippingServicesCard,
  [OnboardingSteps.ShipFrom]: ShipFromCard,
  [OnboardingSteps.CheckoutRates]: CheckoutRatesCard,
};

// The values come from Wistia as they are the ids they assign to the videos they host for us.

export const COMPARE_RATES_VIDEO = 'axtm3qvmt2';
export const CREATE_LABELS_VIDEO = 'l5su8ef55h';
export const AUTOMATION_VIDEO = 'ao8h6jiwyd';
export const BRANDED_TRACKING_VIDEO = '7zpexgaxs2';
export const CREATE_RETURN_LABELS_VIDEO = 'frr430ojq0';
export const SHIP_INTERNATIONALLY_VIDEO = '2n2lq2l7ov';

export const videoIds = [
  COMPARE_RATES_VIDEO,
  CREATE_LABELS_VIDEO,
  AUTOMATION_VIDEO,
  BRANDED_TRACKING_VIDEO,
  CREATE_RETURN_LABELS_VIDEO,
  SHIP_INTERNATIONALLY_VIDEO,
];
